/* eslint-disable camelcase */

import { createSaasAdmins } from '@lib/axios/admin'
import { useMutation, useQueryClient } from 'react-query'
import useSuccess from '@hooks/useSuccess'
import useCloseDialog from '@hooks/useCloseDialog'

const useCreateAdmin = () => {
  const showSuccess = useSuccess('Sukses', 'Sukses Menambah Admin')
  const closeDialog = useCloseDialog()
  const queryClient = useQueryClient()
  const mutation = useMutation(
    ({ name, email, saas_role_id }) => createSaasAdmins(name, email, saas_role_id)
  )

  return (data) => mutation.mutate(data, {
    onError: () => closeDialog(),
    onSuccess: () => {
      showSuccess()
      queryClient.invalidateQueries('saas-admin')
    },
  })
}

export default useCreateAdmin
